import React from "react";

export const MyMarker = ({ text, tooltip, $hover }: any) => {
  const handleClick = () => {
    console.log(`You clicked on ${tooltip}`);
  };

  return (
    <div
      className={$hover ? "circle hover" : "circle absolute z-30"}
      onClick={handleClick}
    >
      <span className="circleText" title={tooltip}>
        {text}
      </span>
    </div>
  );
};
